import { render, staticRenderFns } from "./returnedValueBox.vue?vue&type=template&id=61139af4&scoped=true"
import script from "./returnedValueBox.vue?vue&type=script&lang=js"
export * from "./returnedValueBox.vue?vue&type=script&lang=js"
import style0 from "./returnedValueBox.vue?vue&type=style&index=0&id=61139af4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61139af4",
  null
  
)

export default component.exports